import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arLogin from './assets/locales/ar/login.json';
import arStation from './assets/locales/ar/station.json';
import enLogin from './assets/locales/en/login.json';
import enStation from './assets/locales/en/station.json';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        login: enLogin,
        station: enStation,
      },
      ar: {
        login: arLogin,
        station: arStation,
      },
    },

    supportedLngs: ['en', 'ar'],
    fallbackLng: 'en',
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie'],

      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
    },
    ns: ['common', 'login', 'station'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });
